let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cwtwt")).then(() => parcelRequire('dWIha'));